import type { PriorityPaymentRow } from '@/Network/Types/Responses/PriorityPaymentsResponses'

import { formatPriorityStationTime } from './rowFormat'

/** Q24 — mensagem FIXA, em dois modelos. Edição por empresa fica na fase 2. */
export type PriorityCollectionTemplate = 'NOT_SENT' | 'REJECTED'

export const PRIORITY_COPY_FEEDBACK = 'Mensagem copiada'

const firstName = (fullName: string): string => fullName.trim().split(/\s+/)[0] ?? fullName

/**
 * O modelo "foi rejeitado" só faz sentido com a justificativa do auditor em
 * mãos: sem ela, a frase viraria "foi devolvido: """ e o médico não saberia o
 * que corrigir. Nesse caso vale o modelo de quem não enviou.
 */
export const priorityCollectionTemplateFor = (
  row: PriorityPaymentRow
): PriorityCollectionTemplate =>
  row.situation === 'REJECTED' && Boolean(row.activityRecord?.rejectionJustification)
    ? 'REJECTED'
    : 'NOT_SENT'

export const buildPriorityCollectionMessage = (row: PriorityPaymentRow): string => {
  const place = row.healthUnitName ? `em ${row.healthUnitName}` : `na escala ${row.scheduleName}`
  const when = formatPriorityStationTime(row).text
  const devolution =
    priorityCollectionTemplateFor(row) === 'REJECTED'
      ? `O registro enviado foi devolvido: "${row.activityRecord?.rejectionJustification}" `
      : ''

  return (
    `Olá, Dr(a). ${firstName(row.doctorName)}. Seu plantão de ${when} ${place} é de pagamento ` +
    `prioritário e ainda está sem horário confirmado. ${devolution}` +
    'Envie o Registro de Atividade pelo app para liberar o pagamento.'
  )
}

/** "Copiar cobrança em lote": uma mensagem por plantão, pronta para colar. */
export const buildPriorityBulkCollectionMessage = (rows: PriorityPaymentRow[]): string =>
  rows.map(buildPriorityCollectionMessage).join('\n\n')
